import { isDate } from "./isDate-CItBoGIn.mjs";

//#region src/isObject.ts
/**
* This function checks if the given value is an object.
*
* @category Type Guards
* @example
* ```ts twoslash
* import { isObject } from '@simplisafe/ewok'
*
* console.log(isObject({})) // => true
* console.log(isObject([])) // => false
* console.log(isObject(null)) // => false
* ```
*/
function isObject(obj) {
	return typeof obj === "object" && obj !== null && !Array.isArray(obj) && isDate(obj) === false;
}

//#endregion
export { isObject };
//# sourceMappingURL=isObject-BT3avPK2.mjs.map